import { render, staticRenderFns } from "./CategorySupplyAllSellers.vue?vue&type=template&id=6641b538&scoped=true"
import script from "./CategorySupplyAllSellers.vue?vue&type=script&lang=js"
export * from "./CategorySupplyAllSellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6641b538",
  null
  
)

export default component.exports